const RadixRouter = require('./lib/radix-router');

const radix = new RadixRouter();
const middlewares = [];

function insertRoute(method, path, options, handler) {
    if (typeof options === 'function') {
        handler = options;
        options = {};
    }
    radix.insert(method, path, { handler, ...options });
}

function get(path, options, handler) {
    insertRoute('GET', path, options, handler);
}
function post(path, options, handler) {
    insertRoute('POST', path, options, handler);
}
function put(path, options, handler) {
    insertRoute('PUT', path, options, handler);
}
function patch(path, options, handler) {
    insertRoute('PATCH', path, options, handler);
}
function del(path, options, handler) {
    insertRoute('DELETE', path, options, handler);
}
function use(fn) {
    middlewares.push(fn);
}

function lookup(method, path) {
    return radix.lookup(method, path);
}

module.exports = {
    middlewares,
    get,
    post,
    put,
    patch,
    del,
    delete: del,
    use,
    lookup
};
